import { ProductType } from '@common/enums';
import {
    ApplianceModel,
    ColorModel,
    CornerRadiusModel,
    CutoutLaborModel,
    DiagonalCornerModel,
    EdgeModel,
    OptionalProduct,
    PlumbingProduct,
    ProductDetails,
    TearOutModel,
    WaterfallLabor,
} from '@common/models';

type Product =
    | ApplianceModel // sinks, cookingAppliance, dishWasher, faucet, refrigerator
    | ColorModel
    | CornerRadiusModel
    | CutoutLaborModel
    | DiagonalCornerModel
    | EdgeModel
    | OptionalProduct
    | TearOutModel
    | WaterfallLabor
    | PlumbingProduct;

/**
 * Some product lists contain multiple types of products, so we need a function to determine at runtime
 * @see useProductsAsProductDetails - optionalProducts
 */
type ProductTypeFromFunction = (products: Product) => ProductType;

export const convertProductsToProductDetailsList =
    (productType: ProductType | ProductTypeFromFunction) =>
    (products: Product[]): ProductDetails[] =>
        products.map(
            (product): ProductDetails => ({
                ...product,
                abbrevDesc: product.abbrevDesc ?? product.name,
                consumerDesc: product.consumerDesc ?? product.name,
                expirationPromotionDate: product.expirationPromotionDate
                    ? new Date(product.expirationPromotionDate)
                    : undefined,
                priceWithoutDiscount: product.priceWithoutDiscount ?? product.price,
                productType: typeof productType !== 'function' ? productType : productType(product),
                promos: 'promos' in product && product.promos ? [...product.promos] : [],
                // since we're now starting with the original product, these are extraneous - leaving them for now for reference
                // only attributes that do/may be updated from the original
                // name: product.name,
                // price: product.price,
                // productId: product.productId,
                // unitOfMeasure: product.unitOfMeasure,
                // masterSku: product.masterSku,
                // ...buildQteAttributes(product),
            })
        );
